import * as React from 'react';
import createAxiosInstance from '../../../../api';
import { useAlert } from '../../../../components/Notification';
import { useSelector, useDispatch } from 'react-redux';
import {
  setAllCategoryListAction,
  setEquipmentListAction,
  setEquipmentAllListAction,
  setEquipmentDetailsAction,
  setEquipmentFilterAction,
} from '../../../../stores/actionTypes/equipmentsActions';

export function useHook() {
  const axiosInstance = createAxiosInstance();
  const showAlert = useAlert();
  const dispatch = useDispatch();

  const fetchGetListCategory = async (payload) => {
    // let data = null;
    await axiosInstance
      .post('/listCategory', payload)
      .then((response) => {
        dispatch(setAllCategoryListAction(response?.data?.data));
        // data = response.data?.data;
      })
      .catch(() => {
        dispatch(setAllCategoryListAction([]));
        showAlert('Failed get List category', 'warning');
      });
    // return data;
  };

  const fetchDealerGetListCategory = async (payload) => {
    // let data = null;
    await axiosInstance
      .post('/dealers/listCategory', payload)
      .then((response) => {
        dispatch(setAllCategoryListAction(response?.data?.data));
        // data = response.data?.data;
      })
      .catch(() => {
        dispatch(setAllCategoryListAction([]));
        showAlert('Failed get List category', 'warning');
      });
    // return data;
  };

  const createCategory = async (payload) => {
    // let data = null;
    await axiosInstance
      .post('/createCategory', payload)
      .then((response) => {
        if (response?.data?.success) {
          showAlert('createCategory created successfully', 'success');
        }
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    // return data;
  };

  const createSubCategory = async (payload) => {
    // let data = null;
    await axiosInstance
      .post('/createSubCategory', payload)
      .then((response) => {
        if (response?.data?.success) {
          showAlert('SubCategory created successfully', 'success');
        }
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    // return data;
  };

  const createEquipment = async (payload) => {
    // let data = null;
    await axiosInstance
      .post('/createEquipment', payload)
      .then((response) => {
        if (response?.data?.success) {
          showAlert('Equipment created successfully', 'success');
        }
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    // return data;
  };

  const fetchGetEquipmentList = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/listEquipment', payload)
      .then((response) => {
        dispatch(setEquipmentListAction(response?.data?.data));
        data = response.data;
      })
      .catch(() => {
        dispatch(setEquipmentListAction([]));
        showAlert('Failed get List Equipment', 'warning');
      });
    return data;
  };

  const fetchGetAllEquipmentList = async () => {
    let data = null;
    await axiosInstance
      .post('/listEquipment', {})
      .then((response) => {
        dispatch(setEquipmentAllListAction(response?.data?.data));
        data = response.data?.data;
      })
      .catch(() => {
        dispatch(setEquipmentAllListAction([]));
        showAlert('Failed get List Equipment', 'warning');
      });
    return data;
  };

  const fetchGetAllDealerEquipmentList = async () => {
    let data = [];
    await axiosInstance
      .post('/dealer/listEquipment', {})
      .then((response) => {
        dispatch(setEquipmentAllListAction(response?.data?.data));
        data = response.data?.data;
      })
      .catch(() => {
        dispatch(setEquipmentAllListAction([]));
        showAlert('Failed get List Equipment', 'warning');
      });
    return data;
  };

  const fetchGetEquipmentDetails = async (payload) => {
    await axiosInstance
      .post('/getEquipment', payload)
      .then((response) => {
        dispatch(setEquipmentDetailsAction(response?.data?.data));
      })
      .catch(() => {
        dispatch(setEquipmentDetailsAction({}));
        showAlert('Failed get Equipment Details', 'warning');
      });
  };

  const editEquipment = async (payload) => {
    await axiosInstance
      .post('/updateEquipment', payload)
      .then((response) => {
        if (response?.data?.success) {
          showAlert('Equipment updated successfully', 'success');
        }
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
  };

  const fetchGetEquipmentFilter = async () => {
    await axiosInstance
      .get('/equipmentFilters')
      .then((response) => {
        dispatch(setEquipmentFilterAction(response?.data?.data));
      })
      .catch(() => {
        dispatch(setEquipmentFilterAction([]));
        showAlert('Failed get  Equipment Filter', 'warning');
      });
  };

  const handleDeleteEquipment = async (payload) => {
    await axiosInstance
      .post('/deleteEquipment', payload)
      .then(() => {
        showAlert('Equipment deleted successfully', 'success');
      })
      .catch(() => {
        showAlert('Failed to delete  Equipment', 'warning');
      });
  };

  return {
    fetchGetListCategory,
    fetchDealerGetListCategory,
    createCategory,
    createSubCategory,
    createEquipment,
    fetchGetEquipmentList,
    fetchGetAllEquipmentList,
    fetchGetAllDealerEquipmentList,
    fetchGetEquipmentDetails,
    editEquipment,
    fetchGetEquipmentFilter,
    handleDeleteEquipment,
  };
}
